import React from 'react';
import { Button, Icon, Dropdown } from '@weezevent/nacre';
import { RevisionPanel } from '@weezevent/revisor-front';

export const RevisionDropdownItem = ({ revision, label }) => {
    if (!revision.canSeeHistory) return null;
    return <Dropdown.Item item={label} onClick={revision.toggle} />;
};

export const RevisionTriggerButton = ({ revision, label }) => {
    if (!revision.canSeeHistory) return null;
    return <Button inverted onClick={revision.toggle} icon={<Icon circular={false} className={null} color={null} inverted={false} name="history" />} label={label} />;
};

export const RevisionHistoryPanel = ({ revision }) => {
    const { canSeeHistory, data, loading, error, open, close } = revision;
    if (!canSeeHistory) return null;
    return <RevisionPanel mutations={data} loading={loading} error={error} open={open} onClose={close} />;
};
